import { useEffect } from 'react';

const GA4_ID = process.env.REACT_APP_GA4_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

export default function TrackingInstall() {
  useEffect(() => {
    if (GA4_ID) {
      const existingGa = document.getElementById('ga4-script');
      if (!existingGa) {
        const script = document.createElement('script');
        script.id = 'ga4-script';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
        document.head.appendChild(script);
      }

      if (!window.dataLayer) window.dataLayer = [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      window.gtag('js', new Date());
      window.gtag('config', GA4_ID, { anonymize_ip: true });
    }

    if (CLARITY_ID && !window.clarity) {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = `https://www.clarity.ms/tag/${i}`;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_ID);
    }
  }, []);

  return null;
}
